var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcnDelivery(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "#4B4B7C",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.146 2.146c-.094-.094-.221-.146-.354-.146h-1.7930000000000001c-.552 0-1 .448-1 1s.448 1 1 1h.5c.276 0 .5.224.5.5v3.6390000000000002c0 1.236-1.11 2.176-2.329 1.973l-.253-.042c-.241-.04-.418-.249-.418-.493v-1.076c0-.276-.224-.5-.5-.5h-4.293c-.133 0-.26.052-.351.149-1.19 1.265-1.856 2.938-1.856 4.68 0 .095.077.172.172.172h1.328c.276 0 .494.227.562.495.22.865 1.005 1.505 1.938 1.505.934 0 1.718-.64 1.938-1.505.068-.268.286-.495.562-.495h3c.276 0 .494.227.562.495.22.865 1.005 1.505 1.938 1.505.934 0 1.718-.64 1.938-1.505.068-.268.286-.495.562-.495h1c.276 0 .503-.225.47-.499-.19-1.583-1.276-2.937-2.816-3.45-.097-.032-.173-.108-.205-.205l-.812-2.435c-.079-.236.028-.494.251-.605l.371-.186c.611-.305.743-1.119.26-1.602l-1.873-1.872zm-8.646.854c-.276 0-.5.224-.5.5v3c0 .276.224.5.5.5h3c.276 0 .5-.224.5-.5v-3c0-.276-.224-.5-.5-.5h-3zm2.5 10c0 .552-.448 1-1 1s-1-.448-1-1 .448-1 1-1 1 .448 1 1zm7 1c.552 0 1-.448 1-1s-.448-1-1-1-1 .448-1 1 .448 1 1 1z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnDelivery);
export default __webpack_public_path__ + "static/media/icn_delivery.af3af745.svg";
export { ForwardRef as ReactComponent };